import React from "react";
import "./SearchProduct.css";

const SearchProduct = ({ product }) => {
	const { images, name, briefDescription, price } = product;

	return (
		<div className="SearchProduct">
			<div className="image">
				{images ? (
					<img src={images?.[0]} alt={name} />
				) : (
					<p>No image available</p>
				)}
			</div>
			<div className="details">
				<h4>{name}</h4>
				<p>
					{typeof briefDescription === "string"
						? briefDescription
						: "No description available"}
				</p>
				<div className="prices">
					{price.length > 0 ? (
						price.map((priceEntry, index) => (
							<span key={index}>
								{`${priceEntry.size}: ${priceEntry.amount.toLocaleString(
									"en-US",
									{
										style: "currency",
										currency: "KES",
									}
								)}`}
							</span>
						))
					) : (
						<span>No prices available</span>
					)}
				</div>
			</div>
		</div>
	);
};

export default SearchProduct;
